import { render } from "./CsIcon.vue?vue&type=template&id=6aed5280&scoped=true"
import script from "./CsIcon.vue?vue&type=script&lang=js"
export * from "./CsIcon.vue?vue&type=script&lang=js"

import "./CsIcon.vue?vue&type=style&index=0&id=6aed5280&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aed5280"]])

export default __exports__